export default __webpack_public_path__ + "static/media/forward_thin_333.9d640406.svg";